import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=102f5b56&scoped=true"
import script from "./Tag.js?vue&type=script&lang=js&external"
export * from "./Tag.js?vue&type=script&lang=js&external"
import style0 from "./Tag.scss?vue&type=style&index=0&id=102f5b56&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102f5b56",
  null
  
)

export default component.exports